// extracted by css-extract-rspack-plugin
export default {"FormControl":"default-issue-create-repository-section-module__FormControl__Nd0KnRQ","SelectedRepo":"default-issue-create-repository-section-module__SelectedRepo__OYvlSyk"};